<script>
import { useOverviewStore } from "@/javascript/stores/overview";

export default {
  data() {
    return {
      selectedOption: useOverviewStore().currentInterval || "monthly",
    };
  },
  methods: {
    selectOption(option) {
      if(this.selectedOption !== option){
        this.selectedOption = option;
        this.$emit("intervalChange", option); // Emit the selected interval
      }
    },
  },
};
</script>

<template>
  <div class="toggle-switch">
    <ul class="toggle-options">
      <!-- Daily option -->
      <li
        :class="{ selected: selectedOption === 'daily' }"
        @click="selectOption('daily')"
      >
        <input
          id="daily"
          v-model="selectedOption"
          type="radio"
          value="daily"
        >
        <label for="daily"><span class="full-label">Daily</span><span class="short-label">D</span></label>
      </li>

      <!-- Weekly option -->
      <li
        :class="{ selected: selectedOption === 'weekly' }"
        @click="selectOption('weekly')"
      >
        <input
          id="weekly"
          v-model="selectedOption"
          type="radio"
          value="weekly"
        >
        <label for="weekly"><span class="full-label">Weekly</span><span class="short-label">W</span></label>
      </li>

      <!-- Monthly option -->
      <li
        :class="{ selected: selectedOption === 'monthly' }"
        @click="selectOption('monthly')"
      >
        <input
          id="monthly"
          v-model="selectedOption"
          type="radio"
          value="monthly"
        >
        <label for="monthly"><span class="full-label">Monthly</span><span class="short-label">M</span></label>
      </li>

      <!-- Yearly option -->
      <li
        :class="{ selected: selectedOption === 'yearly' }"
        @click="selectOption('yearly')"
      >
        <input
          id="yearly"
          v-model="selectedOption"
          type="radio"
          value="yearly"
        >
        <label for="yearly"><span class="full-label">Yearly</span><span class="short-label">Y</span></label>
      </li>
    </ul>
  </div>
</template>

<style scoped>
/* Base styles for toggle container */
.toggle-switch {
  @apply border;
  @apply border-default_primary_dark;
  border-radius: 5px;
  display: inline-flex;
  background-color: white;
  padding: 0;

}

/* List styles */
.toggle-options {
  @apply text-default_primary_dark;
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0;
}

.toggle-options li {
  @apply border-r-default_primary_dark;
  @apply border-r;
  position: relative;
  flex: 1;
  padding: 2px 14px;
  cursor: pointer;
  text-align: center;
  transition: background-color 0.3s, color 0.3s;
  &:hover {
    @apply bg-default_primary_lightest;
  }
}

.toggle-options li:last-child {
  border-right: none;
}

.toggle-options li.selected {
  @apply bg-default_primary_dark;
  color: white;
}


/* Hover state for selected items */
.toggle-options li.selected:hover {
  @apply bg-default_primary_dark;
  color: white;
}

/* Hidden radio input */
input[type="radio"] {
  position: absolute;
  opacity: 0.01;
}

label {
  position: relative;
  cursor: pointer;
  display: block;
  width: 100%;
  height: 100%;
  font-size: 14px;
}

.short-label { display: none; }

@media screen and (max-width: 1200px) {
  .toggle-options li { padding: 2px 8px; }
  label { font-size: 12px; }
}

@media screen and (max-width: 768px) {
  .toggle-options li { padding: 2px 6px; }
  label { font-size: 10px; }
  .full-label { display: none; }
  .short-label { display: inline; }
}
</style>
